import React, { useState, useEffect } from "react";
import "../components/styles/blogs.css";

function Blogs() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(
          "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@abdul4smart19",
        );
        const data = await response.json();

        if (data.status === "ok") {
          setPosts(data.items);
        } else {
          setError("Failed to fetch blog posts");
        }
      } catch (err) {
        setError("Error loading blog posts");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const extractReadTime = (content, description) => {
    // Try to extract read time from Medium's content
    const readTimeMatch = content?.match(/(\d+)\s*min\s*read/i);
    if (readTimeMatch) {
      return parseInt(readTimeMatch[1]);
    }

    // Fallback: estimate from description (multiply by 4 for full article)
    const text = stripHtml(description || content);
    const wordsPerMinute = 200;
    const wordCount = text.trim().split(/\s+/).length;
    const estimatedFullWordCount = wordCount * 4; // Estimate full article is 4x longer
    const readTime = Math.ceil(estimatedFullWordCount / wordsPerMinute);
    return Math.max(1, readTime); // At least 1 min
  };

  if (loading) {
    return (
      <div className="blogs-container">
        <div className="loading">Loading blog posts...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blogs-container">
        <div className="error">{error}</div>
      </div>
    );
  }

  return (
    <div className="blogs-container">
      <h1 className="blogs-title">Blogs</h1>
      <p className="blogs-subtitle">
        I write about
        <b className="bold">
          {" "}
          AI, SaaS product, and practical engineering
          insights, with a strong focus on product development, growth, and
          innovation.{" "}
        </b>{" "}
        Follow me on{" "}
        <a
          href="https://medium.com/@abdul4smart19"
          target="_blank"
          rel="noopener noreferrer"
          className="medium-link"
        >
          Medium
        </a>{" "}
        or subscribe to the RSS feed to get notified when I publish a new
        article.
      </p>

      <div className="blogs-list">
        {posts.slice(0, 10).map((post, index) => {
          const description =
            stripHtml(post.description).substring(0, 200) + "...";
          const readTime = extractReadTime(post.content, post.description);
          const formattedDate = formatDate(post.pubDate);

          return (
            <div key={index} className="blog-item">
              <div className="blog-content-left">
                <h2 className="blog-title">{post.title}</h2>
                <div className="blog-meta">
                  <span className="blog-date">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      ></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    {formattedDate}
                  </span>
                  <span className="blog-read-time">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {readTime} min read
                  </span>
                </div>
                <p className="blog-description about-text">{description}</p>
              </div>
              <div className="blog-content-right">
                <a
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blog-read-btn"
                >
                  Read
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Blogs;
